export default __webpack_public_path__ + "static/media/del_alt_fill.059b974f.svg";